<template>
  <div>
    <div class="bg-white p-3">
      <slot name="header" />
      <custom-separator class="my-2" text="Agregados" />
      <custom-result-not-found
        v-if="purchaseOrderNumbers.length == 0"
        text="No cuenta con información disponible."
      />

      <budget-sources
        v-for="(item, index) in purchaseOrderNumbers"
        :key="index"
        :is-read-only="isReadOnly"
        :item="item"
        @remove="onRemove"
      />

      <hr v-if="!isReadOnly" />
      <div v-if="!isReadOnly" class="div-container">
        <validation-observer ref="budgetSourcesObserver" slim>
          <div class="row">
            <div class="col-12 col-md">
              <label class="data-name">Tipo de Programa:</label>
              <custom-drop-down
                v-model="innerModel.programType"
                :class="{
                  'was-Invalidated-select':
                    validated && !innerModel.programType,
                }"
                :clearable="false"
                custom-error-msg="El campo es requerido"
                fieldkey="id"
                fieldname="name"
                :options="programTypes"
                placeholder="Seleccione"
                @input="onProgramTypeChange"
              />
              <error
                v-if="validated && !innerModel.programType"
                message="El campo es requerido."
                variant="no-border"
              />
            </div>
            <div class="col-12 col-md">
              <custom-drop-down
                v-model="innerModel.program"
                :class="{
                  'was-Invalidated-select': validated && !innerModel.program,
                }"
                :clearable="false"
                custom-error-msg="El campo es requerido"
                fieldkey="id"
                fieldname="name"
                label="Programa:"
                :options="programs"
                placeholder="Seleccione"
              />
              <error
                v-if="validated && !innerModel.program"
                message="El campo es requerido."
                variant="no-border"
              />
            </div>
            <div class="col-12 col-md">
              <label class="data-name">Presupuesto:</label>
              <money
                v-model.lazy.number="innerModel.projectedFund"
                v-bind="moneyOptions"
                class="form-control"
                :class="{
                  'was-Invalidated': validated && innerModel.projectedFund <= 0,
                }"
              />
              <error
                v-if="validated && innerModel.projectedFund <= 0"
                message="Favor de añadir un valor mayor de cero"
                variant="no-border"
              />
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-12 col-md">
              <label class="data-name">Account:</label>
              <custom-input
                v-model="innerModel.account"
                :class="{
                  'was-Invalidated': validated && !innerModel.account,
                }"
                custom-error-msg="El campo es requerido"
                maxlength="100"
                type="text"
              />
              <error
                v-if="validated && !innerModel.account"
                message="El campo es requerido."
                variant="no-border"
              />
            </div>
            <div class="col-12 col-md">
              <label class="data-name">Dept:</label>
              <custom-input
                v-model="innerModel.dept"
                :class="{
                  'was-Invalidated': validated && !innerModel.dept,
                }"
                custom-error-msg="El campo es requerido"
                maxlength="100"
                type="text"
              />
              <error
                v-if="validated && !innerModel.dept"
                message="El campo es requerido."
                variant="no-border"
              />
            </div>
            <div class="col-12 col-md">
              <label class="data-name">Fund:</label>
              <custom-input
                v-model="innerModel.fund"
                :class="{
                  'was-Invalidated': validated && !innerModel.fund,
                }"
                custom-error-msg="El campo es requerido"
                maxlength="100"
                type="text"
              />
              <error
                v-if="validated && !innerModel.fund"
                message="El campo es requerido."
                variant="no-border"
              />
            </div>
            <div class="col-12 col-md">
              <label class="data-name">Class:</label>
              <custom-input
                v-model="innerModel.class"
                :class="{
                  'was-Invalidated': validated && !innerModel.class,
                }"
                custom-error-msg="El campo es requerido"
                maxlength="100"
                type="text"
              />
              <error
                v-if="validated && !innerModel.class"
                message="El campo es requerido."
                variant="no-border"
              />
            </div>
            <div class="col-12 col-md">
              <label class="data-name">Bud Ref:</label>
              <custom-input
                id="budRef"
                v-model.lazy.number="innerModel.budRef"
                custom-error-msg="El campo es requerido y debe ser mayor a 0"
                :max="999999"
                :maxlength="'6'"
                :min="0"
                type="number"
              />
              <error
                v-if="
                  validated &&
                    (!innerModel.budRef ||
                      !innerModel.budRef > 0 ||
                      innerModel.budRef > 999999)
                "
                message="El campo es requerido y debe ser mayor a 0 y menor o igual a 999999."
                variant="no-border"
              />
            </div>
            <div class="col-12 col-md">
              <label class="data-name">PC Bus Unit:</label>
              <custom-input
                v-model="innerModel.pcBusUnit"
                :class="{
                  'was-Invalidated': validated && !innerModel.pcBusUnit,
                }"
                custom-error-msg="El campo es requerido"
                maxlength="100"
                type="text"
              />
              <error
                v-if="validated && !innerModel.pcBusUnit"
                message="El campo es requerido."
                variant="no-border"
              />
            </div>
          </div>
          <div class="row mt-3">
            <div v-if="isFederal" class="col-12 col-md-2">
              <label class="data-name">Project:</label>
              <custom-input
                v-model="innerModel.project"
                :class="{
                  'was-Invalidated': validated && !innerModel.prifas,
                }"
                custom-error-msg="El campo es requerido"
              />
              <error
                v-if="validated && !innerModel.prifas"
                message="El campo es requerido."
                variant="no-border"
              />
            </div>
            <div class="col-12 col-md-4">
              <label class="data-name">Prifas:</label>
              <custom-input
                v-model="innerModel.prifas"
                maxlength="500"
                type="text"
              />
            </div>
          </div>
          <div class="d-flex justify-content-end mt-3">
            <action-button
              i="fas fa-file-plus"
              text="Añadir"
              variant="success"
              @click="add"
            />
          </div>
        </validation-observer>
      </div>
    </div>
  </div>
</template>

<script>
import CustomDropDown from 'custom-drop-down';
import CustomInput from 'CustomInput';
import Error from 'custom-error';
import { moneyOptions } from '@/utils/objUtils';
import { Money } from 'v-money';
import ActionButton from 'ActionButton';
import CustomSeparator from 'custom-separator';
import CustomResultNotFound from 'custom-result-not-found';
import alertMixin from '@/mixins/alert.mixin.js';
import { getPrograms } from '@/modules/purchaseService/api.js';
import BudgetSources from '../BudgetSources.vue';
import governmentLevels from '@/utils/constants/governmentLevels';

export default {
  name: 'BudgetSourceFunds',
  components: {
    Error,
    CustomDropDown,
    CustomInput,
    CustomSeparator,
    Money,
    CustomResultNotFound,
    ActionButton,
    BudgetSources,
  },
  mixins: [alertMixin],
  props: {
    model: {
      type: Object,
      required: true,
    },
    programTypes: {
      type: Array,
      default: () => [],
    },
    isReadOnly: {
      type: Boolean,
      default: () => false,
    },
    isActual: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      moneyOptions,
      validated: false,
      innerModel: {
        programType: null,
        account: null,
        dept: null,
        projectedFund: 0,
        fund: null,
        program: null,
        class: null,
        budRef: null,
        pcBusUnit: null,
        prifas: null,
        project: null,
        isActual: this.isActual,
      },
      programs: [],
    };
  },
  computed: {
    isFederal() {
      return this.innerModel.programType?.id == governmentLevels.Federal;
    },
    isState() {
      return this.innerModel.programType?.id == governmentLevels.State;
    },
    purchaseOrderNumbers() {
      return (
        this.model.purchaseOrderNumber.filter(
          (x) => x.isActual == this.isActual
        ) || []
      );
    },
  },
  methods: {
    async onProgramTypeChange() {
      if (!this.innerModel.programType) {
        return;
      }

      const { data } = await getPrograms(this.innerModel.programType.id);

      this.programs = data;
    },
    validate() {
      this.validated = true;

      // Determinar qué campos excluir según el tipo
      const excludeKeys = this.isState
        ? ['project', 'prifas', 'isActual']
        : ['prifas', 'isActual'];
      const filteredModel = Object.fromEntries(
        Object.entries(this.innerModel).filter(
          ([key]) => !excludeKeys.includes(key)
        )
      );

      // Obtener los valores
      const values = Object.values(filteredModel);

      // Validar budRef y el resto de los campos
      const validBudRef = Number(this.innerModel.budRef) > 0;
      const allFilled = values.every(Boolean);

      return values.length > 0 && validBudRef && allFilled;
    },
    async add() {
      const isValid = this.validate();

      if (!isValid) {
        this.ShowToast('', 'Debe completar los campos requeridos', 'error');
        return;
      }
      const budRef = Number(this.innerModel.budRef);

      if (!budRef || budRef <= 0 || budRef > 999999) {
        this.validated = true;
        return;
      }
      this.model.purchaseOrderNumber.push({
        ...this.innerModel,
      });

      this.validated = false;

      Object.keys(this.innerModel).forEach((key) => {
        if (key === 'projectedFund') {
          this.innerModel[key] = 0;
        } else if (key === 'isActual') {
          this.innerModel[key] = this.isActual;
        } else {
          this.innerModel[key] = null;
        }
      });
    },
    setValidation(val) {
      this.validated = val;
    },
    onRemove(item) {
      const i = this.model.purchaseOrderNumber.findIndex((x) => x === item);

      this.model.purchaseOrderNumber.splice(i, 1);

      this.$emit('items-changes', this.model.purchaseOrderNumber);
    },
  },
};
</script>
<style scoped>
.custom-radio ::v-deep .col-12 {
  padding: 0 !important;
}
.custom-font {
  color: #727272;
  font-size: 14px;
}
::v-deep .custom-datetime-picker-container {
  width: 100% !important;
  input[type='text'] {
    width: 100%;
  }
}

.div-container {
  padding: 24px;
  background: white;
  border-radius: 4px;
  outline: 1px solid #e2e2e2;
  outline-offset: -1px;
}

.custom-chips-group ::v-deep .mt-3 {
  margin-top: 0 !important;
}
.custom-chips-group ::v-deep .chips-container {
  margin-top: 0 !important;
}
.custom-chips-group ::v-deep .chips-container .bold {
  font-weight: 400 !important;
}

.custom-chips-group ::v-deep .chips-container .label > .inline {
  font-size: 1rem;
  font-weight: 700 !important;
  color: #1b1b1b !important;
}

input.was-Invalidated,
.was-Invalidated ::v-deep input,
div.was-Invalidated-select ::v-deep .v-select > div {
  background-color: #f7d7da;
  border: 1px solid #ff0018 !important;
}
::v-deep div.was-Invalidated {
  border: none !important;
}
</style>
